document.addEventListener('DOMContentLoaded', async function () {

	// Only run if page has the target selector
	if (!document.querySelector('.dynamic-link-desc')) {
		return;
	}


	let collections = [];

	try {
		const response = await fetch('https://mp.villageorganic.co.uk/api/site/wholefoodsbox/get-dynamic-links');
		collections = await response.json();
	} catch (error) {
		console.error('Failed to fetch dynamic links:', error);
		return;
	}

	// Create a flat list of all keywords and their corresponding URLs
	let allKeywords = [];
	collections.forEach(collection => {
		collection.keywords.forEach(keyword => {
			allKeywords.push({
				keyword: keyword,
				url: collection.url
			});
		});
	});

	// Sort by keyword length (longest first)
	allKeywords.sort((a, b) => b.keyword.length - a.keyword.length);

	// Target multiple content containers
	const contentContainers = [
		'.dynamic-link-desc',
		// Add more selectors as needed
	];

	// Function to safely process HTML content
	function processHTML(html) {
		// Create a DOM parser
		const parser = new DOMParser();
		const doc = parser.parseFromString(`<div>${html}</div>`, 'text/html');
		const container = doc.body.firstChild;

		// Track which keywords have been linked
		const linkedKeywords = new Set();

		// Function to walk the DOM tree and process text nodes
		function walkDOM(node, inAnchor = false) {
			// Skip if this is a script or style element
			if (node.nodeName === 'SCRIPT' || node.nodeName === 'STYLE') {
				return;
			}

			// Check if we're entering an anchor tag
			const nodeIsAnchor = node.nodeName === 'A';
			const currentInAnchor = inAnchor || nodeIsAnchor;

			// If this is a text node and not inside an anchor, process it
			if (node.nodeType === Node.TEXT_NODE && !inAnchor && node.textContent.trim() !== '') {
				let replacements = [];
				let text = node.textContent;

				// Find all potential keyword matches
				allKeywords.forEach(item => {
					// Skip if this keyword has already been linked
					if (linkedKeywords.has(item.keyword.toLowerCase())) {
						return;
					}

					const escapedKeyword = item.keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
					const regex = new RegExp(`\\b${escapedKeyword}\\b`, 'gi');

					let match;
					while ((match = regex.exec(text)) !== null) {
						replacements.push({
							start: match.index,
							end: match.index + match[0].length,
							matchedText: match[0],
							keyword: item.keyword,
							url: item.url
						});
					}
				});

				// Sort replacements by position (start index)
				replacements.sort((a, b) => a.start - b.start);

				// Filter out overlapping replacements (keep only the first one at each position)
				replacements = replacements.filter((rep, i) => {
					if (i === 0) return true;
					return rep.start >= replacements[i - 1].end;
				});

				// If we have replacements, apply them
				if (replacements.length > 0) {
					// Create a document fragment to hold the new content
					const fragment = document.createDocumentFragment();
					let lastIndex = 0;

					replacements.forEach(rep => {
						// Add text before this replacement
						if (rep.start > lastIndex) {
							fragment.appendChild(document.createTextNode(text.substring(lastIndex, rep.start)));
						}

						// Create the link
						const link = document.createElement('a');
						link.href = rep.url;
						link.className = 'dynamic_link';
						link.target = '_blank';
						link.title = `View ${rep.keyword} collection`;
						link.textContent = rep.matchedText; // Preserve original case

						// Mark this keyword as linked
						linkedKeywords.add(rep.keyword.toLowerCase());

						fragment.appendChild(link);
						lastIndex = rep.end;
					});

					// Add any remaining text
					if (lastIndex < text.length) {
						fragment.appendChild(document.createTextNode(text.substring(lastIndex)));
					}

					// Replace the original text node
					node.parentNode.replaceChild(fragment, node);
				}
			}
			// Process child nodes recursively
			else if (node.hasChildNodes()) {
				const childNodes = Array.from(node.childNodes);
				childNodes.forEach(child => {
					walkDOM(child, currentInAnchor);
				});
			}
		}

		// Process the container's DOM
		walkDOM(container);

		// Return the processed HTML
		return container.innerHTML;
	}

	// Process each container
	contentContainers.forEach(selector => {
		const containers = document.querySelectorAll(selector);

		containers.forEach(container => {
			// Process the HTML and update the container
			container.innerHTML = processHTML(container.innerHTML);
		});
	});

});